import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import { find } from 'lodash';
import Select from 'react-select';
import queryString from 'query-string';

import { Alert } from 'react-bootstrap';
import { Input, Loader } from 'sa-ui';

import AddProfileApproveModal from './approve-modal/AddProfileApproveModal';

import { getAbbreviation } from '../app/utils/strings';

import {
  resetProfile,
  getProfile,
  getSchools,
  getProfilesTypes,
  getEvaluations,
  addTeacher,
  editTeacher,
  getFilteredCatalogins,
} from './addProfileActions';

import messages from './addProfileMessages';

import './AddProfileContainer.scss';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    border: 'none',
    color: state.isSelected ? '#ec745d' : '#8d8d8d',
    fontWeight: state.isSelected ? '600' : 'normal',
    background: '#ffffff',
  }),
};

const initialState = {
  name: '',
  school: '',
  role: '',
  evaluations: [],
  cataloging: '',
  email: '',
  password: '',
  viewEvaluation: false,
  allowEdit: false,
  allowValidate: false,
  hasError: false,
  success: false,
  fetchProfile: false,
  queryStringValues: {},
};

class AddProfileContainer extends Component {
  state = initialState;

  componentDidMount() {
    const { location, dispatch } = this.props;
    const queryStringValues = queryString.parse(location.search);

    queryStringValues &&
      this.setState({
        queryStringValues,
        isLoading: true,
        fetchProfile: true,
      });

    dispatch(getSchools({ profile: 'true' }));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(resetProfile());
    this.setState(initialState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { dispatch, history } = this.props;

    if (prevProps.success !== this.props.success && this.props.success) {
      this.setState({
        success: true,
        isLoading: false,
        queryStringValues: {},
      });
    }

    if (prevProps.hasError !== this.props.hasError && this.props.hasError && !this.props.apiError) {
      this.setState({
        isLoading: false,
        hasError: true,
        errorMessage: this.props.intl.formatMessage(messages.errorGeneric),
      });
    }

    if (prevProps.apiError !== this.props.apiError && this.props.apiError) {
      this.setState({
        isLoading: false,
        hasError: true,
        errorMessage: this.props.apiError,
      });
    }

    if (
      this.state.fetchProfile &&
      this.state.queryStringValues &&
      this.state.queryStringValues.idCSchool
    ) {
      dispatch(getProfile({ ...this.state.queryStringValues }));
      this.setState({ fetchProfile: false });
    }

    if (
      this.state.fetchProfile &&
      this.state.queryStringValues &&
      !this.state.queryStringValues.idCSchool
    ) {
      this.setState({ fetchProfile: false, isLoading: false });
    }

    if (prevProps.profile.idCSchool !== this.props.profile.idCSchool) {
      const { profile, intl } = this.props;

      this.fetchData(profile.idCSchool)
        .then(() => {
          const { schools, catalogings, evaluations } = this.props;

          const school = find(schools, (s) => s.idCSchool === profile.idCSchool);
          const cataloging = find(catalogings, (c) => c.id === profile.idCataloging);
          const addedEvaluations = evaluations.filter((e) => {
            const t = profile.evaluations.filter((el) => el.idEvaluation === e.id);
            return t.length > 0;
          });

          setTimeout(() => {
            this.setState({
              isLoading: false,
              email: profile.email,
              name: profile.name,
              allowEdit: true,
              role:
                profile.permission === '0'
                  ? { label: intl.formatMessage(messages.teacher), value: '0' }
                  : { label: intl.formatMessage(messages.coordinator), value: '1' },
              // evaluations: addedEvaluations,
              school,
              cataloging,
            });
          }, 1000);
        })
        .catch((err) => this.setState({ isLoading: false }));
    }
  }

  showError = () => (
    <div className="alert-wrapper">
      <Alert variant="danger" onClick={() => this.setState({ hasError: false, errorMessage: '' })}>
        <Alert.Heading>{this.props.intl.formatMessage(messages.errorTitle)}</Alert.Heading>
        <p dangerouslySetInnerHTML={{ __html: this.state.errorMessage }} />
      </Alert>
    </div>
  );

  showSuccess = () => (
    <div className="alert-wrapper">
      <Alert variant="success" onClick={() => this.setState({ success: false })}>
        <p>{this.props.intl.formatMessage(messages.successTitle)}</p>
      </Alert>
    </div>
  );

  validade = () => {
    const { intl, email } = this.props;
    const { queryStringValues } = this.state;
    const regexEmail = /\S+@\S+\.\S+/;
    const emailIsValid = regexEmail.test(this.state.email);

    if (!this.state.name) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorInput, {
          field: intl.formatMessage(messages.name),
        }),
      });
      return false;
    }

    if (!this.state.school) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorSelect, {
          field: intl.formatMessage(messages.school),
        }),
      });
      return false;
    }

    if (!this.state.role) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorSelect, {
          field: intl.formatMessage(messages.role),
        }),
      });
      return false;
    }

    if (this.state.role.value === '0' && this.state.evaluations.length === 0) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorSelect, {
          field: intl.formatMessage(messages.evaluations),
        }),
      });
      return false;
    }

    if (!this.state.email) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorInput, {
          field: intl.formatMessage(messages.email),
        }),
      });
      return false;
    }

    if (!emailIsValid) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorEmailNotValid),
      });
      return false;
    }

    if (this.state.email === email) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorEmail),
      });
      return false;
    }

    if (this.state.queryStringValues.idCSchool) {
      return true;
    }

    if (!this.state.password && !queryStringValues.idCSchool) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorInput, {
          field: intl.formatMessage(messages.password),
        }),
      });
      return false;
    }

    if (String(this.state.password).length < 6) {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorPasswordLength),
      });
      return false;
    }

    if (this.state.evaluations.length === 0 && this.state.role.value === '0') {
      this.setState({
        hasError: true,
        errorMessage: intl.formatMessage(messages.errorEvaluationsRequired),
      });
      return false;
    }

    return true;
  };

  save = async () => {
    const success = this.validade();
    if (!success) {
      return setTimeout(() => {
        this.setState({
          hasError: false,
          errorMessage: '',
        });
      }, 3000);
    }

    const { dispatch } = this.props;
    const idEvaluation = this.state.evaluations.map((e) => e.id);

    const params = {
      idEvaluation,
      name: this.state.name,
      idCSchool: this.state.school.idCSchool,
      idProfileType: this.state.role.value,
      email: this.state.email,
      password: this.state.password,
      // edit: this.state.allowEdit ? '1' : '0',
      // validateQuestions: this.state.allowValidate ? '1' : '0',
      // viewEvaluation: this.state.viewEvaluation ? '1' : '0',
      edit: '0',
      validateQuestions: '0',
      viewEvaluation: '0',
    };

    if (this.state.cataloging) {
      params.idCatalogingSegment = this.state.cataloging.id;
    }

    dispatch(addTeacher(params));
  };

  fetchData = (idCSchool) => {
    const { dispatch } = this.props;

    return new Promise((resolve, reject) => {
      idCSchool && dispatch(getProfilesTypes({ idCSchool }));
      idCSchool && dispatch(getEvaluations({ idCSchool }));
      dispatch(
        getFilteredCatalogins({
          catalogingType: 'segment',
          idCSchool,
        }),
      );
      setTimeout(() => {
        resolve();
      }, 2000);
    });
  };

  render() {
    const { schools, evaluations, catalogings, dispatch, isLoading, intl, history } = this.props;
    const roles = this.props.roles.map((r) => ({
      ...r,
      label:
        r.label === 'teacher'
          ? intl.formatMessage(messages.teacher)
          : intl.formatMessage(messages.coordinator),
    }));

    const initials = getAbbreviation(this.state.name);

    const isDisabled = !!this.props.profile.idCSchool;

    return (
      <div id="add-profile" className="container">
        <Loader show={isLoading || this.state.isLoading} />
        <h1 className="page-title mb-5">{intl.formatMessage(messages.title)}</h1>
        <div className="row">
          <div className="col-sm-3">
            <div className="change-avatar mb-4">
              <div className="color-switch-popup">
                <input id="color1" type="radio" name="avatar-color" />>
                <label htmlFor="color1" style={{ backgroundColor: '#abe0de' }}>
                  <i className="fa fa-check" />
                </label>
                <input id="color2" type="radio" name="avatar-color" />
                <label htmlFor="color2" style={{ backgroundColor: '#d4a1dd' }}>
                  <i className="fa fa-check" />
                </label>
                <input id="color3" type="radio" name="avatar-color" />
                <label htmlFor="color3" style={{ backgroundColor: '#c5e2a9' }}>
                  <i className="fa fa-check" />
                </label>
                <input id="color4" type="radio" name="avatar-color" />
                <label htmlFor="color4" style={{ backgroundColor: '#efd581' }}>
                  <i className="fa fa-check" />
                </label>
                <input id="color5" type="radio" name="avatar-color" />
                <label htmlFor="color5" style={{ backgroundColor: '#9bc4ed' }}>
                  <i className="fa fa-check" />
                </label>
              </div>
              <div className="ca-content">
                <input id="avatar-file" type="file" name="avatar" />
                <div
                  className="class-prefix class-prefix-edit"
                  style={{ backgroundColor: '#C5E2A9' }}
                >
                  {initials}
                </div>
                {/* <button className="ca-button ca-button-left color-switch-button">
                  <i className="ti-paint-bucket"></i>
                  {intl.formatMessage(messages.color)}
                </button>
                <label className="ca-button ca-button-right" htmlFor="avatar-file">
                  <i className="pe-7s-camera"></i>
                  {intl.formatMessage(messages.photo)}
                </label> */}
              </div>
            </div>
          </div>
          <div className="col-sm-9">
            <h2 className="section-title">
              <i className="pe-7s-tools" />
              {intl.formatMessage(messages.userData)}
            </h2>
            <form action="nova-escola.pug" method="post">
              <div className="form-group">
                <Input
                  label={intl.formatMessage(messages.name)}
                  name="name"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  disabled={isDisabled}
                />
              </div>
              <div className="form-group">
                <label htmlFor="form-cargo">{intl.formatMessage(messages.school)}</label>
                <Select
                  placeholder={intl.formatMessage(messages.select)}
                  className={`form-control sm-select ${isDisabled ? 'disabled' : ''}`}
                  value={this.state.school}
                  options={schools}
                  onChange={(school) =>
                    this.setState({ school }, () => this.fetchData(school.idCSchool))
                  }
                  styles={customStyles}
                  isDisabled={isDisabled}
                />
              </div>
              <div className="form-group">
                <label htmlFor="form-cargo">{intl.formatMessage(messages.role)}</label>
                <Select
                  placeholder={intl.formatMessage(messages.select)}
                  className={`form-control sm-select ${isDisabled ? 'disabled' : ''}`}
                  value={this.state.role}
                  options={roles}
                  onChange={(role) => this.setState({ role })}
                  isDisabled={roles.length === 0 || isDisabled}
                  styles={customStyles}
                />
              </div>
              {this.state.role.value === '0' && (
                <div className="form-group">
                  <label htmlFor="form-cargo">{intl.formatMessage(messages.evaluations)}</label>
                  <Select
                    placeholder={intl.formatMessage(messages.select)}
                    className="form-control sm-select"
                    value={this.state.evaluations}
                    options={evaluations}
                    onChange={(evaluations) => this.setState({ evaluations })}
                    isDisabled={evaluations.length === 0}
                    styles={customStyles}
                    isMulti
                  />
                </div>
              )}
              <div className="form-group">
                <label htmlFor="form-cargo">{intl.formatMessage(messages.catalogings)}</label>
                <Select
                  placeholder={intl.formatMessage(messages.select)}
                  className={`form-control sm-select ${isDisabled ? 'disabled' : ''}`}
                  value={this.state.cataloging}
                  options={catalogings}
                  onChange={(cataloging) => this.setState({ cataloging })}
                  isDisabled={catalogings.length === 0 || isDisabled}
                  styles={customStyles}
                />
              </div>
              <div className="form-group">
                <Input
                  label={intl.formatMessage(messages.email)}
                  name="email"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  disabled={isDisabled}
                />
              </div>
              {!isDisabled && (
                <div className="form-group">
                  <Input
                    label={intl.formatMessage(messages.password)}
                    name="password"
                    type="password"
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                  <small className="form-text text-muted" id="emailHelp">
                    {intl.formatMessage(messages.passwordRule)}
                  </small>
                </div>
              )}
              {/* <p className="mt-5">
                <strong>{intl.formatMessage(messages.permissions)}</strong>
              </p>
              <div className="row">
                <div className="col-4">
                  <ul className="pl-0" style={{ listStyle: 'none' }}>
                    <li className="switch">
                      {intl.formatMessage(messages.views)}
                      <span className="switch mr-0 float-right">
                        <input
                          id="switchView"
                          type="checkbox"
                          value={this.state.viewEvaluation}
                          checked={this.state.viewEvaluation}
                          onChange={() =>
                            this.setState({ viewEvaluation: !this.state.viewEvaluation })
                          }
                        />
                        <label htmlFor="switchView" />
                      </span>
                    </li>
                    {this.state.viewEvaluation && (
                      <li className="switch">
                        {intl.formatMessage(messages.validateQuestions)}
                        <span className="switch mr-0 float-right">
                          <input
                            id="switchValidate"
                            type="checkbox"
                            value={this.state.allowValidate}
                            checked={this.state.allowValidate}
                            onChange={() =>
                              this.setState({ allowValidate: !this.state.allowValidate })
                            }
                          />
                          <label htmlFor="switchValidate" />
                        </span>
                      </li>
                    )}
                    <li className="switch">
                      {intl.formatMessage(messages.edit)}
                      <span className="switch mr-0 float-right">
                        <input
                          id="switchEdit"
                          type="checkbox"
                          value={this.state.allowEdit}
                          checked={this.state.allowEdit}
                          onChange={() => this.setState({ allowEdit: !this.state.allowEdit })}
                        />
                        <label htmlFor="switchEdit" />
                      </span>
                    </li>
                  </ul>
                </div>
              </div> */}
            </form>
            <div className="row mt-5">
              <div className="col-6">
                <a
                  className="btn btn-block btn-outline-primary"
                  onClick={() => {
                    this.setState({ queryStringValues: {} }, () =>
                      setTimeout(() => history.push('/profiles')),
                    );
                  }}
                >
                  {intl.formatMessage(messages.cancel)}
                </a>
              </div>
              <div className="col-6">
                <a className="btn btn-block btn-primary" onClick={this.save}>
                  {intl.formatMessage(messages.save)}
                </a>
              </div>
            </div>
          </div>
        </div>
        {this.state.hasError && this.showError()}
        <AddProfileApproveModal
          name={this.state.name}
          isOpen={this.state.success}
          onClose={() => {
            this.setState({ success: false });
          }}
          onContinue={() => {
            this.setState(
              {
                success: false,
                isLoading: true,
              },
              () => {
                setTimeout(() => history.push('/profiles'), 1000);
              },
            );
          }}
        />
      </div>
    );
  }
}

function mapStateToProps({ app, profiles, addProfile }) {
  return {
    email: app.user.email,
    profiles,
    ...addProfile,
  };
}

export default compose(injectIntl, withRouter, connect(mapStateToProps))(AddProfileContainer);
